(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahaPdpStickyInit) return;
  window.__ahaPdpStickyInit = true;

  function init() {
    var bar = document.querySelector('[data-pdp-sticky]');
    if (!bar) return;

    var form = document.querySelector('form[data-product-form]');
    var realAdd = form ? form.querySelector('[data-add-to-cart]') : null;
    var realPrice = document.querySelector('[data-product-price]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    var stickyAddText = bar.querySelector('[data-sticky-add-text]');
    var hasMO = typeof window.MutationObserver === 'function';

    // Mirror the live price (never re-uses [data-product-price] so the
    // variant picker in theme.js keeps targeting the canonical element).
    function syncPrice() {
      if (realPrice && stickyPrice) stickyPrice.innerHTML = realPrice.innerHTML;
    }
    syncPrice();
    if (realPrice && hasMO) {
      new MutationObserver(syncPrice).observe(realPrice, {
        childList: true, characterData: true, subtree: true
      });
    }

    // Mirror the real add button's disabled state + label.
    function syncAdd() {
      if (!realAdd || !stickyAdd) return;
      var disabled = realAdd.disabled || realAdd.hasAttribute('disabled');
      stickyAdd.disabled = disabled;
      stickyAdd.classList.toggle('is-disabled', disabled);
      var src = realAdd.querySelector('[data-add-text]');
      if (src && stickyAddText) stickyAddText.textContent = src.textContent;
    }
    syncAdd();
    if (realAdd && hasMO) {
      new MutationObserver(syncAdd).observe(realAdd, {
        attributes: true, attributeFilter: ['disabled'],
        childList: true, characterData: true, subtree: true
      });
    }

    // Sticky button submits the ONE canonical form (no duplicate form).
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (stickyAdd.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }

    // Reveal the bar only when the real add-to-cart leaves the viewport.
    function show(state) {
      bar.classList.toggle('is-visible', state);
      bar.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.body.classList.toggle('pdp-sticky-open', state);
    }
    if (realAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { show(!entry.isIntersecting); });
      }, { threshold: 0 }).observe(realAdd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
